import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import React, { useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getSpecialization, deleteSpecialization } from "../../../../actions/configuration";
import { LangCtx } from "../../../../lib/context";
import Loader from "../../../../lib/ui/loader/Loader";
import "../../../../ui-styles/list/contactListAction.css";
import CreateSpecialization from "./createSpecialization";
import SpecializationCard from "./specializationCard";
import "../../../../ui-styles/search/Search.css";
import useDebounce from "../../../common/useDebounce";
import NoData from "../../../../lib/ui/nodata/NoData";
import { TablePagination } from "@material-ui/core";


const Specialization = () =>
{
    const { l } = useContext(LangCtx);
    const [ open, setOpen ] = React.useState(false);
    const [ specializationList, setSpecialization ] = useState([]);
    const [ count, setCount ] = useState(0);
    const [ loading, setLoading ] = useState(false);
    const [ searchTerm, setSearchTerm ] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const [ page, setPage ] = useState(0);
    const [ rowsPerPage, setRowsPerPage ] = useState(10);

    // const searchRef = useRef('');

    // let itemsPerPage = 5;


    const handleClickOpen = () =>
    {
        setOpen(true);
    };

    const handleClose = (stat = false) =>
    {
        // setPage(0);
        if (stat === true)
        {
            getSpecializationData();
        }
        setOpen(false);
    };

    const getSpecializationData = () =>
    {
        setLoading(true);

        let query = `?limit=${rowsPerPage}&skip=${page}`;

        if (searchTerm)
        {
            query += `&searchKey=${searchTerm}`;
        }

        getSpecialization(query)
            .then((res) =>
            {
                if (res.status)
                {
                    setCount(res.count);
                    setSpecialization(res?.data);
                } else
                {
                    setSpecialization([]);
                    // setCount(0);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch((err) =>
            {
                toast.POSITION(err?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
                // setCount(0);
            });
    };

    const handleDelete = (id) =>
    {
        setLoading(true);
        deleteSpecialization(id)
            .then((res) =>
            {
                if (res.status)
                {
                    toast.success(l.spce_del, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    // setPage(0);
                    getSpecializationData();
                    // setOpenDelOpen(false);
                } else
                {
                    console.log("error");
                }
                setLoading(false);
            })
            .catch((err) =>
            {
                toast.error(err?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
            });
    };

    // useEffect(() =>
    // {

    //         // searchRef.current = searchTerm;
    //         setPage(0);
    //         getSpecializationData();
    //     // }
    // }, [ debouncedSearchTerm ]);

    useEffect(() =>
    {
        getSpecializationData();
    }, [ page, debouncedSearchTerm, rowsPerPage ]);

    const handleChangePage = (event, newPage) =>
    {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) =>
    {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <div className="flexCol pos-rel">
            {loading && <Loader />}
            <div className="resColRow pdngMD">
                <div className="flexMinWidthCol">
                    <span className="topHdngTxt">{l.specialization_list}</span>
                    <span className="lightTxt">{l.belowlist_specializations_created}</span>
                </div>
                <div className="flexAutoRow alignRight resMobPdng">
                    <Button variant="contained" color="primary" className="whiteTxt" onClick={handleClickOpen}>
                        <AddIcon />
                        {l.create_specialization}
                    </Button>
                </div>
            </div>
            <div className="searchCntnr">
                <div className="searchBox searchFull">
                    <div className="searchForm">
                        <input
                            className="textbox"
                            type="text"
                            placeholder={l.plc_search}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            {specializationList?.length > 0 ? (
                <>
                    <div className="flexCol pdngHztSM">
                        <SpecializationCard
                            specializationList={specializationList}
                            handleDelete={handleDelete}
                            setPage={setPage}
                            loadData={getSpecializationData}
                        />
                    </div>
                    <div className="flexCol justifyEnd">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
                    {/* {specializationList?.length !== count && (
                        <div className="flexRow alignCenter justifyCenter mrgnTopXS">
                            <Button variant="contained" color="primary" onClick={handleLoadMore} className="whiteTxt">
                                Load More
                            </Button>
                        </div>
                    )} */}
                </>
            ) : !loading ? (
                <NoData src="/images/file-icons/blank-file.png" Heading={l.nospec_found} label={l.nospecdesc_found} />
            ) : (
                ""
            )}

            {open && <CreateSpecialization open={open} handleClose={handleClose} />}
        </div>
    );
};

export default Specialization;
